export class SideMenuItem {
  constructor(
    public title: string,
    public isShown: boolean,
    public icon: string,
    public url: string,
    public onClick = () => {
      console.warn('empty click handler');
    }
  ) {
    if (!icon) {
      this.icon = '';
    }
  }
}
